<div class="emma-dropdown" ngbDropdown>
    <button
        ngbDropdownToggle
        emmaButton
        class="dropdown-toggle"
        [color]="color"
        (click)="onOpen()"
        [disabled]="disabled"
        [hasIcon]="!!buttonIcon"
    >
        <span>
            <i *ngIf="buttonIcon" class="la la-{{ buttonIcon }}" aria-hidden="true"></i>
            <span *ngIf="buttonLabel">{{ buttonLabel }}</span>
        </span>
    </button>
    <div ngbDropdownMenu class="emma-dropdown-menu">
        <div class="dropdown-menu--grid-tiles">
            <div class="dropdown-menu--tile">
                <emma-input
                    *ngIf="searchable"
                    placeholder="Filtrar..."
                    [autofocus]="true"
                    [disabled]="disabled"
                    [ngModel]="searchTerm"
                    (ngModelChange)="onSearchChange($event)"
                    i18n-placeholder
                ></emma-input>
                <ng-container *ngIf="groupBy && _groupedItems && _groupedHeaders.length">
                    <ng-container *ngFor="let header of _groupedHeaders">
                        <button [disabled]="true" class="groupby" ngbDropdownItem>
                            <span>{{ header }}</span>
                        </button>
                        <button
                            *ngFor="let item of _groupedItems[header]"
                            [disabled]="disabled"
                            ngbDropdownItem
                            (click)="onSelect(item)"
                        >
                            <span>{{ item.label }}</span>
                        </button>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!groupBy">
                    <button
                        *ngFor="let item of _items"
                        [disabled]="disabled"
                        ngbDropdownItem
                        (click)="onSelect(item)"
                    >
                        <span>
                            <i *ngIf="item.icon" class="{{ item.icon }}" aria-hidden="true"></i>
                            <span>{{ item.label }}</span>
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
